import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  orderItemDetailsContainer: {},
  orderItemDetailsHeader: {},
  orderItemDetailsHeaderText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
  flyoutContainer: {},
  noDetailsMessageText: {
    fontSize: styleVars.rem(.875),
  },
  deliveryDetailsContent: {},
  deliveryDetailItemContainer: {},
  deliveryDetailItemStatus: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingVertical: styleVars.rem(.125),
  },
  sectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingVertical: styleVars.rem(.125),
  },
  sectionLabel: {
    maxWidth: '45%',
  },
  sectionLabelText: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  sectionValue: {
    maxWidth: '50%',
  },
  sectionValueText: {
    fontSize: styleVars.rem(.875),
    textAlign: 'right',
  },
});